export default __webpack_public_path__ + "static/media/perrinita2.9af59bfa.jpg";